<div class="input-wrapper" [class.is-disabled]="disabled()">
  <i *ngIf="icon" [attr.class]="'input-icon ' + icon"></i>

  <input
    #inputEl
    type="text"
    class="ig-autocomplete-input"
    [class.invisible]="showCustomSelectedItemTemplate()"
    [class.p-inputtext-lg]="inputLarge"
    pInputText
    [placeholder]="placeholder"
    [(ngModel)]="inputValue"
    [disabled]="disabled()"
    [attr.id]="inputId"
    role="autocomplete"
    aria-autocomplete="list"
    [attr.aria-controls]="overlay.id"
    [attr.aria-expanded]="overlay.visible() ? 'true' : 'false'"
    aria-haspopup="listbox"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledby"
    (keydown)="onKeyPress($event)"
    (focus)="onInputFocus($event)"
    (blur)="onInputBlur($event)"
  />

  @let myTemplateSelectedItem = templateSelectedItem();
  <ng-container *ngIf="myTemplateSelectedItem && showCustomSelectedItemTemplate()">
    <div class="selected-item-template" (igA11yLink)="inputEl.focus()">
      <ng-template *ngTemplateOutlet="myTemplateSelectedItem; context: { $implicit: myValue() }"></ng-template>
    </div>
  </ng-container>
</div>

<div *ngIf="multiple" class="selected-values">
  <div *ngFor="let value of selectedValues()" class="selected-value">
    {{ value.label }}
    <i class="fal fa-times-circle" [attr.title]="'delete' | uitranslate" [attr.aria-label]="'delete' | uitranslate" (igA11yLink)="onRemoveSelected(value)"></i>
  </div>
</div>


<!-- the overlay -->
<ig-autocomplete-overlay
  #overlay
  [target]="inputEl"
  [panelStyleClass]="panelStyleClass"
  (onKeyEsc)="onKeyEsc($event)"
  (onKeyArrowDown)="onKeyArrowDown($event)"
  (onKeyArrowUp)="onKeyArrowUp($event)"
>
  <div [style.minHeight]="suggestionsLoading() ? '200px' : ''">
    <ig-loader *ngIf="suggestionsLoading()" [size]="'parentSize'"></ig-loader>

    <ng-container *ngIf="templateHeader">
      <ng-template *ngTemplateOutlet="templateHeader"></ng-template>
    </ng-container>

    <ng-container *ngTemplateOutlet="suggestionsTemplate; context: { suggestions: suggestionsVisible() }"></ng-container>

    <div class="empty-state" *ngIf="suggestionsVisible().length < 1">
      <ng-container *ngIf="templateEmpty">
        <ng-template *ngTemplateOutlet="templateEmpty"></ng-template>
      </ng-container>
      <ng-container *ngIf="!templateEmpty">
        {{ 'AUTOCOMPLETE.NO_RESULTS' | uitranslate }}
      </ng-container>
    </div>

    <div *ngIf="templateFooter" #footer>
      <ng-template *ngTemplateOutlet="templateFooter"></ng-template>
    </div>

  </div>
</ig-autocomplete-overlay>


<!-- templates -->
<ng-template #suggestionsTemplate let-suggestions="suggestions">
  <ul
    class="ig-autocomplete-items"
    role="listbox"
    [attr.aria-activedescendant]="overlayEl?.id + '_item_' + focusIndex()"
    [attr.aria-required]="forceSelection ? 'true' : 'false'"
    [attr.aria-multiselectable]="multiple ? 'true' : 'false'"
    aria-label="Suggestions"
  >
    <ng-container *ngFor="let suggestion of suggestions">
      @if(suggestion.children?.length) {
        <ng-container *ngTemplateOutlet="suggestionGroupTemplate; context: { group: suggestion }"></ng-container>
      }
      @else {
        <ng-container *ngTemplateOutlet="suggestionItemTemplate; context: { item: suggestion }"></ng-container>
      }
    </ng-container>
  </ul>
</ng-template>

<ng-template #suggestionItemTemplate let-item="item">
  <li
    role="option"
    class="ig-autocomplete-item a11y-no-focus-visible"
    [class.ig-highlight]="isSelected(item.value)"
    [class.ig-focus]="focusIndex() === getFlatIndex(item)"
    [attr.aria-selected]="isSelected(item.value) ? 'true' : 'false'"
    [attr.id]="overlayEl?.id + '_item_' + getFlatIndex(item)"
    igAutocompleteOverlayFocus
    (focus)="onItemFocus(getFlatIndex(item))"
    (blur)="onItemBlur()"
    (igA11yLink)="onSelectSuggestion(item)"
  >

  <ng-container *ngIf="templateItem">
    <ng-template *ngTemplateOutlet="templateItem; context: { $implicit: item }"></ng-template>
  </ng-container>
  <ng-container *ngIf="!templateItem">
    <span>{{ item.label }}</span>
  </ng-container>
  </li>
</ng-template>

<ng-template #suggestionGroupTemplate let-group="group">
  <li
    role="group"
    class="ig-autocomplete-item-group"
  >
    <ng-container *ngIf="templateGroup">
      <ng-template *ngTemplateOutlet="templateGroup; context: { $implicit: group }"></ng-template>
    </ng-container>
    <ng-container *ngIf="!templateGroup">
      <span>{{ group.label }}</span>
    </ng-container>

    <ng-container *ngTemplateOutlet="suggestionsTemplate; context: { suggestions: group.children }"></ng-container>
  </li>
</ng-template>
